import React from 'react';
import { Heading, Pane, Card, Button } from 'evergreen-ui';

// const defaultActionButtonProps = {
//     justifyContent: 'center',
//     onBack: () => window.history.back(),
//     onConfirm: undefined,
//     backLabel: 'Back',
//     confirmLabel: undefined
// }

const Layout = ({ title, fullHeight = false, maxWidth, children, actionButtonProps = undefined }) => {
  return (
    <Pane marginTop={fullHeight ? undefined : "10vh"} width="100%" height={fullHeight ? '100vh' : undefined} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      {title && typeof title === 'string' && (
        <Heading size={800} marginBottom="12px">
          {title}
        </Heading>
      )}
      {title && typeof title !== 'string' && title}
      <Card width="80%" maxWidth={maxWidth || 350} display="flex" flexDirection="column" justifyContent="center" alignItems="center" padding="30px">
        {children}
      </Card>
      {actionButtonProps && (
        <Pane marginTop="24px" marginBottom="24px" display="flex" justifyContent={actionButtonProps.justifyContent || 'center'} alignItems="center" width="100%">
          {actionButtonProps.onBack && <Button onClick={actionButtonProps.onBack}>{actionButtonProps.backLabel || 'Go back'}</Button>}
          {actionButtonProps.onConfirm && (
            <Button onClick={actionButtonProps.onConfirm} appearance="primary">
              {actionButtonProps.confirmLabel || 'Confirm'}
            </Button>
          )}
        </Pane>
      )}
    </Pane>
  );
};

export default Layout;
